"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const Device = __importStar(require("../../../device"));
const Protocol = __importStar(require("../protocol"));
const authorization_1 = require("./authorization");
const Error = __importStar(require("./error"));
const tracing_1 = require("./tracing");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Alarm';
const alarmIdParam = platform_1.HttpApiSchema.param('alarmId', Device.Class.ActiveAlarm.AlarmId);
const updateAlarm = platform_1.HttpApiEndpoint.put('updateAlarm') `/${alarmIdParam}`
    .setPayload(Device.History.Alarm)
    .addSuccess(Protocol.responseBodySuccess(Device.History.Alarm))
    .addError(Error.NotFoundErrorFromProtocol)
    .addError(Error.ValidationErrorFromProtocol)
    .addError(Error.NotAuthorizedErrorFromProtocol)
    .addError(Error.InternalServerErrorFromProtocol)
    .annotate(platform_1.OpenApi.Title, 'Update Alarm')
    .annotate(platform_1.OpenApi.Description, 'Update Alarm');
exports.Spec = platform_1.HttpApiGroup.make('alarm')
    .middleware(authorization_1.UserAuthorization)
    .middleware(tracing_1.Tracing)
    .add(updateAlarm)
    .prefix('/alarm')
    .annotate(platform_1.OpenApi.Title, 'Alarm')
    .annotate(platform_1.OpenApi.Description, 'Alarm management');
//# sourceMappingURL=alarm.js.map